import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/images/empty-team-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-73c1327c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "EmptyTeamGuide"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "EmptyTeamGuide__text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "EmptyTeamGuide__hightlight" }, "已获得20KK币")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "EmptyTeamGuide__text" }, " 邀请1位好友组成队伍即可领取 ", -1))
const _hoisted_5 = {
  key: 1,
  class: "EmptyTeamGuide"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "EmptyTeamGuide__icon",
  src: _imports_0
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "EmptyTeamGuide__text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "EmptyTeamGuide__hightlight" }, "2人"),
  /*#__PURE__*/_createTextVNode("即可组队 ")
], -1))
const _hoisted_8 = { class: "EmptyTeamGuide__text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 最多赚")
const _hoisted_10 = { class: "EmptyTeamGuide__hightlight" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "EmptyTeamGuide__text" }, " 本期居然还没有队伍，快来组建第一个吧 ", -1))
const _hoisted_12 = { class: "EmptyTeamGuide__text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "EmptyTeamGuide__hightlight" }, "2人", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("即可组队，最多赚")
const _hoisted_15 = { class: "EmptyTeamGuide__hightlight" }

import { useStore } from '@/store';
import { computed } from 'vue';
import { globalData } from '@/global';


export default /*#__PURE__*/_defineComponent({
  props: {
    mode: null
  },
  setup(__props: any) {



const store = useStore();
const maxKkbCanObtain = computed(() => store.state.rule.maxKkbCanObtain);
const avatar = computed(() => store.state.user.avatar);
const isShare = store.state.isShare;
const isKuaikan = globalData.isKuaikan;


return (_ctx: any,_cache: any) => {
  return (!_unref(isShare) && _unref(isKuaikan))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "EmptyTeamGuide__icon",
          src: _unref(avatar)
        }, null, 8, _hoisted_2),
        _hoisted_3,
        _hoisted_4
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _hoisted_6,
        (__props.mode === 'team')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(maxKkbCanObtain)) + "KK币", 1)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(maxKkbCanObtain)) + "KK币", 1)
              ])
            ], 64))
      ]))
}
}

})